import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import TextRenderer from '../TextRenderer';
import PollAnswer from '../DaEditorWrapper/Viewer/PollAnswer';
import PollOptionThumb from './PollOptionThumb';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import localStyles from './PollOption.scss';
const DEFAULT_IMAGE_SIZE_MOBILE = 72;
const DEFAULT_IMAGE_SIZE_DESKTOP = 84;
const PollOption = ({ answer, className, canVote, draftJsThemeOverride, answerClassName, stylesheet: s = localStyles, imageSize, hoverImageSize = 0, onClick })=>{
    const isMobile = useContext(MobileContext);
    const logEvent = useBiLogger();
    const handleClick = useCallback((event)=>{
        if (!answer.answerId || !canVote) {
            return;
        }
        // should allow clicks through that are on links inside the answer
        const parentLink = event.target.closest(`.${s['answer-text']} a`);
        if (parentLink) {
            // force said link into a new tab
            window.open(parentLink.href, '', 'noopener');
            event.preventDefault();
            return;
        }
        logEvent(BiData({
            evid: 115,
            pollid: BiContextProvidedValue
        }));
        onClick(answer.answerId);
    }, [
        answer.answerId,
        canVote,
        logEvent,
        onClick,
        s
    ]);
    const thumbSize = imageSize || (isMobile ? DEFAULT_IMAGE_SIZE_MOBILE : DEFAULT_IMAGE_SIZE_DESKTOP);
    const imageBlockStyles = {
        width: thumbSize,
        height: thumbSize,
        flexBasis: thumbSize
    };
    const adjX = thumbSize + 4;
    const adjY = -(hoverImageSize / 2 - thumbSize / 2);
    const hoverStyles = hoverImageSize ? {
        width: hoverImageSize,
        height: hoverImageSize,
        transform: `translate(${adjX}px, ${adjY}px)`
    } : {};
    const hasImage = !!answer.deviationId;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], canVote && s['can-vote'], className)
    }, hasImage && /*#__PURE__*/ React.createElement("div", {
        className: s['image-block'],
        style: imageBlockStyles
    }, /*#__PURE__*/ React.createElement(PollOptionThumb, {
        deviation: answer.image,
        size: thumbSize
    })), !!hoverImageSize && hasImage && /*#__PURE__*/ React.createElement("div", {
        className: s['image-block-hover'],
        style: hoverStyles
    }, /*#__PURE__*/ React.createElement(PollOptionThumb, {
        deviation: answer.image,
        size: hoverImageSize
    })), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['text-block'], hasImage && s['has-image']),
        onClick: handleClick
    }, answer.textContent && /*#__PURE__*/ React.createElement(TextRenderer, _object_spread({
        htmlExcerptLegacy: true,
        isPollWithHtmlExcerpt: true,
        className: classnames(s['answer-text'], answerClassName),
        textContent: answer.textContent,
        reactViewer: PollAnswer,
        viewerKey: answer.answerId,
        legacyTheme: "poll-answer"
    }, draftJsThemeOverride ? {
        draftJsThemeOverride
    } : {})), !canVote && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['progress-bar']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['progress-bar__value'],
        style: {
            width: `${answer.percentvotes}%`
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['percent-votes']
    }, answer.percentvotes, "%"))));
};
PollOption.displayName = 'PollOption';
export default PollOption;

//# sourceMappingURL=PollOption.js.map